import { jsx as _jsx } from "react/jsx-runtime";
import * as jdenticon from 'jdenticon';
import React, { useMemo } from 'react';
function Identicon({ className = '', publicKey, size, style }) {
    const html = useMemo(() => ({ __html: jdenticon.toSvg(publicKey.substring(2), size) }), [publicKey, size]);
    return (_jsx("div", { className: className, dangerouslySetInnerHTML: html, style: style }));
}
export const Jdenticon = React.memo(Identicon);
